<template>
  <app-popup :active.sync="isActive" title="История начислений" class="employee-accruals-history-popup" width="1100px">
    <vs-table :data="accrualsHistoryFiltered" hoverFlat max-items="10" pagination
              class="employee-accruals-history-popup__table"
              noDataText="История начислений пуста">
      <template slot="thead">
        <vs-th>Месяц</vs-th>
        <vs-th>Тип помещения</vs-th>
        <vs-th>Дата и время</vs-th>
        <vs-th>Статус</vs-th>
        <vs-th>Начислено</vs-th>
        <vs-th>Ошибок</vs-th>
        <vs-th>Автор</vs-th>
      </template>
      <template slot-scope="{data}" ref="content">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{tr.log.month}}</vs-td>
          <vs-td>{{tr.log.apartments_type}}</vs-td>
          <vs-td>{{tr.created_at}}</vs-td>
          <vs-td>
            <template v-if="tr.status === ACCRUALS_STATUSES.done">
              <div class="employee-accruals-history-popup__status">
                <div class="employee-accruals-history-popup__status-icon">
                  <feather-icon icon="CheckCircleIcon" svg-classes="text-success"
                                title="Расчет начислений завершен"/>
                </div>
                <span>Завершено</span>
              </div>
            </template>
            <template v-if="tr.status === ACCRUALS_STATUSES.process">
              <div class="employee-accruals-history-popup__status employee-accruals-history-popup__status_process">
                <div class="employee-accruals-history-popup__status-info">
                  <div class="employee-accruals-history-popup__status-text" v-if="tr.current_action" :title="tr.current_action">{{tr.current_action}}</div>
                  <div class="employee-accruals-history-popup__status-progress">
                    <div class="employee-accruals-history-popup__status-progress-text">
                      <div>{{Number(tr.percent)}}%</div>
                    </div>
                    <vs-progress :percent="Number(tr.percent)" color="warning" :title="tr.percent" height="15"/>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="tr.status === ACCRUALS_STATUSES.error">
              <div class="employee-accruals-history-popup__status">
                <div class="employee-accruals-history-popup__status-icon">
                  <feather-icon icon="XCircleIcon" svg-classes="text-danger" title="Ошибка"/>
                </div>
                <span>Ошибка</span>
              </div>
            </template>

          </vs-td>
          <vs-td>
            <div class="text-center">
              {{tr.success !== null ? tr.success : '-'}}
            </div>
          </vs-td>
          <vs-td>
            <div class="employee-accruals-history-popup__error">
              <div class="employee-accruals-history-popup__error-text">
                {{tr.denied !== null ? tr.denied : '-'}}
              </div>
              <div class="link-icon employee-accruals-history-popup__error-icon" v-if="tr.log.errors.length" @click="openErrorsPopup(tr.log.errors)">
                <app-icon name="InfoIcon2" size="16px"/>
              </div>

            </div>
          </vs-td>
          <vs-td>{{tr.who ? tr.who.name : 'Не известно'}}</vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <errors-popup ref="errorsPopup"/>
  </app-popup>
</template>

<script>
  import ErrorsPopup from "@/components/calculated-program/accruals/ErrorsPopup";

  const ACCRUALS_STATUSES = {
    process: 0,
    done: 1,
    error: 2,
  };

  export default {
    name: "HistoryPopup",
    components: {
      ErrorsPopup
    },
    props: {
      buildingsId: {
        required: true
      }
    },
    data() {
      return {
        ACCRUALS_STATUSES: ACCRUALS_STATUSES,
        isActive: false,
        historyInterval: null,
        history: [],
        showOnlyOwn: false,
      }
    },
    computed: {
      apartmentsTypes() {
        return this.$store.getters['appUser/availableApartmentsTypes'];
      },
      userId() {
        return this.$store.getters['appUser/id'];
      },
      accrualsHistoryFiltered() {
        let history = this.history;
        if (this.showOnlyOwn) {
          history = history.filter(historyLocal => historyLocal.who && historyLocal.who.id === this.userId);
        }
        return history;
      }
    },
    methods: {
      open() {
        this.isActive = true;
        this.setHistoryInterval();
      },
      close() {
        this.active = false;
        this.clearHistoryInterval();
      },
      async setHistoryInterval() {
        await this.getHistory();
        this.historyInterval = setInterval(this.getHistory, 3000);
      },
      clearHistoryInterval() {
        clearInterval(this.historyInterval);
      },
      async getHistory() {
        try {
          let {data} = await this.$http.get('charge_status', {
            params: {
              buildings_id: this.buildingsId,
            }
          });

          const defaultChargeLogObject = {
            month: "-",
            apartments_type: "-",
            errors: []
          };

          this.history = data.map(charge => {
            let oldCharge = this.history.find(oldCharge => oldCharge.id === charge.id);
            if (oldCharge) {
              charge.percent = oldCharge.percent > charge.percent ? oldCharge.percent : charge.percent;
              charge.denied = oldCharge.denied > charge.denied ? oldCharge.denied : charge.denied;
              charge.success = oldCharge.percent > charge.success ? oldCharge.success : charge.success;
            }

            if (charge.log) {
              try {
                charge.log = JSON.parse(charge.log);

                if (charge.log.month) {
                  charge.log.month = this.$capitalize(this.$options.filters.moment(this.$parseDateFromString(charge.log.month), "MMMM YYYY"));
                } else {
                  charge.log.month = defaultChargeLogObject.month;
                }

                if (charge.log.apartments_type !== null) {
                  charge.log.apartments_type = this.getApartmentTypeById(charge.log.apartments_type);
                } else {
                  charge.log.apartments_type = defaultChargeLogObject.apartments_type;
                }

                if(!charge.log.errors){
                  charge.log.errors = defaultChargeLogObject.errors
                }

              } catch (e) {
                charge.log = defaultChargeLogObject;
              }
            } else {
              charge.log = defaultChargeLogObject;
            }

            charge.created_at = this.$options.filters.moment(charge.created_at, 'DD.MM.YYYY HH:mm:ss');
            charge.current_action = "";

            return charge;
          });

        } catch (e) {
          this.history = [];
        }
      },
      getApartmentTypeById(id) {
        let type = this.apartmentsTypes.find(type => Number(type.id) === Number(id));
        return type ? type.name : (Number(id) === 999 ? 'Одиночное начисление' : '');
      },
      openErrorsPopup(errors){
        this.$refs.errorsPopup.open(errors);
      }
    },
    beforeDestroy() {
      this.clearHistoryInterval();
    },
    watch: {
      isActive(){
        if(!this.isActive){
          this.clearHistoryInterval();
        }
      }
    }
  }
</script>

<style lang="scss">
  .employee-accruals-history-popup {
    &__table {
      .vs-table--tbody {
        border: none;
        background: #fff;
      }

      .vs-table--thead th {
        padding: 0 !important;
        border-bottom: 1px solid rgba(0, 0, 0, .125);

        .vs-table-text {
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }

        &:not(:first-child){
          .vs-table-text{
            text-align: center;
            justify-content: center;
          }
        }
      }

      .vs-table {
        .vs-table--tr:nth-child(2n+1) {
          background: #f5f8fa;
        }
      }

      .tr-values td {
        padding: .5rem 10px;
        font-size: 12px;

        span{
          min-height: 50px;
          display: flex;
          align-items: center;
        }

        &:not(:first-child){
          span{
            text-align: center;
            justify-content: center;
          }
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }

    &__status{
      width: 225px;
      display: flex;
      align-items: center;
      justify-content: center;

      &-icon{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: 5px;
        width: 20px;
        height: 20px;

        .feather-icon{
          width: 100%;
          height: 100%;

          svg{
            width: 100%;
            height: 100%;
          }
        }
      }

      &-info{
        width: calc(100% - 25px);
      }

      &_process{
       .employee-accruals-history-popup__status-info{
         width: 100%;
       }
      }

      &-text{
        font-size: 12px;
        line-height: 1.1;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 5px;
        margin-bottom: 4px;
      }

      &-progress{
        position: relative;
        width: 100%;
        display: flex;

        &-text{
          position: absolute;
          height: 100%;
          width: 100%;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          z-index: 9999;
          line-height: 1;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
        }

      }
    }

    &__error{
      display: flex;
      align-items: center;
      justify-content: center;

      &-icon{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 5px;
      }
    }
  }
</style>
